import React from 'react'
import { FormError } from 'components/atoms'
import { RadioMarked, RadioUnmarked } from 'components/icons'
import styles from './FormRadio.module.sass'

export interface OptionProps {
  id: string
  label?: string
  name?: string
  value?: any
  checked?: boolean
  variant?: '' | 'buttons' | 'questionario'
  className?: string
  readOnly?: boolean
  required?: boolean
  disabled?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

interface Props {
  id: string
  label?: string
  name?: string
  value?: any
  className?: string
  readOnly?: boolean
  required?: boolean
  disabled?: boolean
  variant?: '' | 'buttons' | 'questionario'
  status?: '' | 'success' | 'error'
  errorMessage?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  options: OptionProps[]
}

const FormRadioOption = (props: OptionProps) => {
  const {
    id = '',
    label = '',
    name = '',
    value = '',
    checked = false,
    variant = '',
    className = '',
    readOnly = false,
    required = false,
    disabled = false,
    onChange = () => {},
  } = props

  const classNames = `
    ${styles.option}
    ${variant ? styles[`option--${variant}`] : ''}
    ${disabled ? styles['option--disabled'] : ''}
    ${className}`

  return (
    <div className={classNames}>
      <label htmlFor={id} className={styles.inputWrap}>
        <input
          id={id}
          checked={checked}
          name={name}
          value={value}
          className={styles.input}
          type="radio"
          readOnly={readOnly}
          required={required}
          disabled={disabled}
          onChange={onChange}
        />
        <span className={styles.styledInput}>
          {checked ? <RadioMarked /> : <RadioUnmarked />}
        </span>
        <span className={styles.label}>{label}</span>
      </label>
    </div>
  )
}

const FormRadio = (props: Props) => {
  const {
    id = '',
    name = '',
    value = null,
    label = undefined,
    className = '',
    readOnly = false,
    required = false,
    disabled = false,
    variant = '',
    status = '',
    errorMessage = '',
    onChange = () => {},
    options = [],
  } = props

  const onOptionChange = (e: any) => {
    if (!e.target.disabled && !e.target.readOnly) onChange(e)
  }

  const classNames = `
    ${styles.root} 
    ${disabled ? styles['root--disabled'] : ''}
    ${variant ? styles[`root--${variant}`] : ''}
    ${status ? styles[`root--${status}`] : ''}
    ${className}`

  return (
    <div className={classNames}>
      <div className={styles.options}>
        {options?.map((option) => (
          <FormRadioOption
            id={`${id}-${option.value}`}
            name={name}
            label={option.label}
            value={option.value}
            checked={option.value === value}
            variant={variant}
            onChange={onOptionChange}
            readOnly={readOnly || option.readOnly}
            required={required || option.required}
            disabled={disabled || option.disabled}
            key={`formradiooption-${id}-${option.value}`}
          />
        ))}
      </div>
      <FormError
        id={`${id}_error`}
        message={errorMessage}
        visible={status === 'error'}
        className={styles.error}
      />
    </div>
  )
}

export default FormRadio
